import { render, staticRenderFns } from "./CheckTmzStep.vue?vue&type=template&id=3cd64ce9&scoped=true&"
import script from "./CheckTmzStep.vue?vue&type=script&lang=js&"
export * from "./CheckTmzStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd64ce9",
  null
  
)

export default component.exports